import type { RouteModule } from "bunfx";

export const routes: Record<string, () => Promise<RouteModule>> = {
  "": () => import("./home"),
  demo: () => import("./demo"),
  login: () => import("./login"),
  signup: () => import("./signup"),
  "signup/complete": () => import("./signup/complete"),
  forgotpassword: () => import("./forgotpassword"),
  verify: () => import("./verify"),
  account: () => import("./account"),
  "account/email-confirm": () => import("./account-email-confirm"),
  "account/password-reset": () => import("./account-password-reset"),
  orgs: () => import("./orgs"),
  "orgs/new": () => import("./orgs/new"),
  "orgs/:orgId": () => import("./home"),
  "orgs/:orgId/team": () => import("./orgs/team"),
  "orgs/:orgId/members": () => import("./orgs/members"),
  "orgs/:orgId/members/:memberId": () => import("./orgs/member-profile"),
  "orgs/:orgId/members/:memberId/profile": () =>
    import("./orgs/member-profile"),
  "orgs/:orgId/admin/members/:memberId": () => import("./orgs/member-admin"),
  "orgs/:orgId/high-fives": () => import("./orgs/high-fives"),
  "orgs/:orgId/values": () => import("./orgs/core-values"),
  "orgs/:orgId/values/digest": () => import("./orgs/values-digest"),
  "orgs/:orgId/org-chart": () => import("./orgs/org-chart"),
  "orgs/:orgId/invite": () => import("./orgs/invite"),
  "orgs/:orgId/accept": () => import("./orgs/accept"),
  "orgs/:orgId/forms": () => import("./orgs/forms"),
  "orgs/:orgId/groups": () => import("./orgs/groups"),
  "orgs/:orgId/forms/bank": () => import("./orgs/forms/bank"),
  "orgs/:orgId/forms/bank/:questionId": () => import("./orgs/forms/bank-edit"),
  "orgs/:orgId/forms/:formId": () => import("./orgs/forms/submit"),
  "orgs/:orgId/forms/:formId/edit": () => import("./orgs/forms/edit"),
  "orgs/:orgId/forms/:formId/results": () => import("./orgs/forms/results"),
  "orgs/:orgId/feed": () => import("./orgs/feed"),
  "orgs/:orgId/review": () => import("./orgs/review"),
  "orgs/:orgId/settings": () => import("./orgs/settings"),
  "orgs/:orgId/time-off": () => import("./orgs/time-off"),
  "orgs/:orgId/check-ins": () => import("./orgs/check-ins"),
  "orgs/:orgId/forms/:formId/submissions/:submissionId": () =>
    import("./orgs/forms/submit"),
  "*slug": () => import("./not-found"),
};
